export const COMPANY = {
  name: "BNM Group",
  tagline: "International Trading & Industrial Supply",
  description:
    "BNM Group is an international trading and industrial supply company headquartered in Ankara, Turkey, operating across petrochemicals, industrial machinery, transportation systems, agricultural commodities and telecommunications infrastructure.",
  address:
    "Kızılırmak Mah. Dumlupınar Bulv. No:3, Next Level A Blok Kat:16, Ankara, Turkey",
  phone: "+90 552 022 72 00",
  phoneRaw: "+905520227200",
  email: "info@bnm.com.tr",
  website: "https://www.bnm.com.tr",
  founded: 2008,
  offices: ["Ankara · Headquarters", "Dubai · Middle East", "Almaty · Central Asia", "Lagos · Africa"],
};

export const HERO_SLIDES = [
  {
    eyebrow: "General Trading",
    title: "GLOBAL TRADING &\nINDUSTRIAL SUPPLY",
    subtitle:
      "BNM Group operates in international trade, connecting global suppliers and buyers across multiple industries including petrochemical products, industrial machinery, transportation systems, agricultural commodities, and telecommunications infrastructure.",
    image:
      "https://static.prod-images.emergentagent.com/jobs/992269a5-240d-47a2-94bf-57af67715604/images/107173358a58b4fd951837fe4813b7bcfbd17e66dd1538255a609f5864d5d57d.png",
    ctas: [
      { label: "Request a Quote", to: "/quote", primary: true },
      { label: "Talk to a Trader", to: "/contact", primary: false },
    ],
  },
  {
    eyebrow: "Petrochemicals",
    title: "POLYMERS, BASE OIL\n& RAW MATERIALS",
    subtitle:
      "Polyethylene, polypropylene, PVC and base oil — sourced from tier-one refineries and delivered on disciplined terms.",
    image:
      "https://static.prod-images.emergentagent.com/jobs/992269a5-240d-47a2-94bf-57af67715604/images/4acbb80021f186925ac20fcacc521c5700b6a298dc53aa81bd022cefc5f6a531.png",
    ctas: [
      { label: "Request a Quote", to: "/quote", primary: true },
      { label: "Petrochemicals", to: "/industries/petrochemical-products", primary: false },
    ],
  },
  {
    eyebrow: "Rail & Railway Systems",
    title: "RAIL INFRASTRUCTURE\nAT GLOBAL SCALE",
    subtitle:
      "Railway infrastructure, rolling stock components and rail transport systems for national operators and private freight networks.",
    image:
      "https://images.unsplash.com/photo-1474487548417-781cb71495f3?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
    ctas: [
      { label: "Request a Quote", to: "/quote", primary: true },
      { label: "Rail Systems", to: "/industries/rail-railway-systems", primary: false },
    ],
  },
  {
    eyebrow: "Aviation & Engine Electronics",
    title: "AVIATION-GRADE\nCOMPONENTS.",
    subtitle:
      "Aircraft components, engine electronics and aviation technologies sourced from certified OEM and MRO partners.",
    image:
      "https://images.unsplash.com/photo-1556388158-158ea5ccacbd?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
    ctas: [
      { label: "Request a Quote", to: "/quote", primary: true },
      { label: "Aviation", to: "/industries/aviation-engine-electronics", primary: false },
    ],
  },
  {
    eyebrow: "Agricultural Commodities",
    title: "FROM HARVEST\nTO WORLD MARKETS.",
    subtitle:
      "Corn, wheat, barley, soybean and sunflower meal — origin-diversified agricultural programs for institutional buyers.",
    image:
      "https://static.prod-images.emergentagent.com/jobs/992269a5-240d-47a2-94bf-57af67715604/images/0997b2d90ef0c9db4b378fccd9a0a198956d96c70362400303de922dfc3143d5.png",
    ctas: [
      { label: "Request a Quote", to: "/quote", primary: true },
      { label: "Agriculture", to: "/industries/food-agricultural-commodities", primary: false },
    ],
  },
  {
    eyebrow: "Vehicles & Heavy Equipment",
    title: "HEAVY TRANSPORT\nFOR EVERY TERRAIN.",
    subtitle:
      "Passenger vehicles, trucks, construction equipment and heavy machinery — trusted brands, negotiated fleet pricing.",
    image:
      "https://images.unsplash.com/photo-1586191582056-b7f0e16b3a09?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
    ctas: [
      { label: "Request a Quote", to: "/quote", primary: true },
      { label: "Vehicles", to: "/industries/vehicles-heavy-equipment", primary: false },
    ],
  },
  {
    eyebrow: "Telecommunications",
    title: "INFRASTRUCTURE\nFOR CONNECTED ECONOMIES.",
    subtitle:
      "Telecommunication systems, networking equipment and infrastructure technology for operators and governments.",
    image:
      "https://images.unsplash.com/photo-1558346490-a72e53ae2d4f?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
    ctas: [
      { label: "Request a Quote", to: "/quote", primary: true },
      { label: "Telecom", to: "/industries/telecommunications-infrastructure", primary: false },
    ],
  },
];

export const INDUSTRIES = [
  {
    id: "rail-railway-systems",
    number: "01",
    title: "Rail & Railway Systems",
    short: "Rail",
    description:
      "Supply of railway infrastructure and rail transport equipment for national operators, metro authorities and freight networks.",
    longDescription:
      "BNM Group sources railway infrastructure, rolling stock components, track systems and rail transport equipment for operators across Europe, MENA, Central Asia and Africa. We partner with certified manufacturers and handle end-to-end logistics, documentation and commissioning support.",
    keyItems: [
      "Rolling stock components",
      "Track systems & sleepers",
      "Signalling & electrification",
      "Rail freight wagons",
      "Maintenance-of-way equipment",
    ],
    image:
      "https://images.unsplash.com/photo-1474487548417-781cb71495f3?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
  },
  {
    id: "aviation-engine-electronics",
    number: "02",
    title: "Aviation & Engine Electronics",
    short: "Aviation",
    description:
      "Aircraft components, engine electronics, and aviation technologies sourced from certified OEM and MRO partners.",
    longDescription:
      "Our aviation desk handles aircraft components, engine electronics and aviation technologies — supporting airline MRO programs, lessors and defence operators. Every shipment is accompanied by full certification and traceability documentation.",
    keyItems: [
      "Engine electronics",
      "Aircraft rotable & consumable parts",
      "Avionics & navigation systems",
      "Ground support equipment",
      "MRO component sourcing",
    ],
    image:
      "https://images.unsplash.com/photo-1556388158-158ea5ccacbd?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
  },
  {
    id: "petrochemical-products",
    number: "03",
    title: "Petrochemical Products",
    short: "Petchem",
    description:
      "Polyethylene, polypropylene, PVC, base oil and petrochemical materials for industrial manufacturers.",
    longDescription:
      "We source and distribute petrochemical products — polyolefins, PVC, base oils and specialty chemicals — from tier-one refineries across the Gulf, Europe and Asia. Physical-backed contracts, full specs and on-time delivery.",
    keyItems: [
      "Polyethylene (LDPE, LLDPE, HDPE)",
      "Polypropylene (homopolymer, copolymer)",
      "Polyvinyl chloride (PVC)",
      "Base oil (Group I, II, III)",
      "Specialty petrochemical grades",
    ],
    image:
      "https://static.prod-images.emergentagent.com/jobs/992269a5-240d-47a2-94bf-57af67715604/images/4acbb80021f186925ac20fcacc521c5700b6a298dc53aa81bd022cefc5f6a531.png",
  },
  {
    id: "industrial-machinery",
    number: "04",
    title: "Industrial Machinery",
    short: "Machinery",
    description:
      "Manufacturing equipment, factory systems and industrial production lines for mid-to-large industrial buyers.",
    longDescription:
      "From complete production lines to specialised processing equipment, BNM Group structures capex-grade equipment purchases — including installation, commissioning and training coordination with OEM partners.",
    keyItems: [
      "Production lines & factory systems",
      "Processing & packaging equipment",
      "CNC & metalworking machinery",
      "Industrial pumps, compressors & motors",
      "Spare parts & consumables",
    ],
    image:
      "https://images.unsplash.com/photo-1565792508000-8aca4a9be4c3?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
  },
  {
    id: "food-agricultural-commodities",
    number: "05",
    title: "Food & Agricultural Commodities",
    short: "Agriculture",
    description:
      "Grains, legumes and agricultural export products — origin-diversified and inspection-verified.",
    longDescription:
      "Our agricultural desk trades corn, wheat, barley, soybean meal and sunflower meal through origin-diversified programs. Every shipment is backed by pre-shipment inspection and standard GAFTA / FOSFA contracts.",
    keyItems: [
      "Corn, wheat, barley",
      "Soybean meal & sunflower meal",
      "Legumes & pulses",
      "Edible oils",
      "Agricultural export logistics",
    ],
    image:
      "https://static.prod-images.emergentagent.com/jobs/992269a5-240d-47a2-94bf-57af67715604/images/0997b2d90ef0c9db4b378fccd9a0a198956d96c70362400303de922dfc3143d5.png",
  },
  {
    id: "vehicles-heavy-equipment",
    number: "06",
    title: "Vehicles & Heavy Equipment",
    short: "Vehicles",
    description:
      "Passenger vehicles, trucks and heavy machinery for commercial fleets and infrastructure projects.",
    longDescription:
      "BNM Group supplies passenger vehicles, commercial trucks, construction equipment and heavy machinery from leading global brands — with negotiated fleet pricing and full after-sales logistics coordination.",
    keyItems: [
      "Passenger & commercial vehicles",
      "Heavy trucks & trailers",
      "Construction equipment (excavators, loaders)",
      "Mining & earth-moving machinery",
      "After-sales parts & servicing",
    ],
    image:
      "https://images.unsplash.com/photo-1586191582056-b7f0e16b3a09?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
  },
  {
    id: "telecommunications-infrastructure",
    number: "07",
    title: "Telecommunications & Infrastructure",
    short: "Telecom",
    description:
      "Telecommunication systems, networking equipment and infrastructure technology for operators and governments.",
    longDescription:
      "We source and supply telecommunications infrastructure — from core networking equipment and fibre-optic systems to data centre components — partnering with certified manufacturers serving operators and public-sector clients.",
    keyItems: [
      "Core & access networking equipment",
      "Fibre-optic & transmission systems",
      "Data centre infrastructure",
      "Wireless & microwave technology",
      "Power & cooling systems",
    ],
    image:
      "https://images.unsplash.com/photo-1558346490-a72e53ae2d4f?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
  },
];

export const PRODUCT_CATEGORIES = [
  {
    id: "petrochemical-products",
    title: "Petrochemical Products",
    description:
      "High-grade polymers and base oils sourced directly from tier-one refineries.",
    image:
      "https://static.prod-images.emergentagent.com/jobs/992269a5-240d-47a2-94bf-57af67715604/images/4acbb80021f186925ac20fcacc521c5700b6a298dc53aa81bd022cefc5f6a531.png",
    items: ["Polyethylene", "Polypropylene", "PVC", "Base Oil"],
  },
  {
    id: "agricultural-products",
    title: "Agricultural Products",
    description:
      "Origin-diversified grain, meal and commodity programs with full traceability.",
    image:
      "https://static.prod-images.emergentagent.com/jobs/992269a5-240d-47a2-94bf-57af67715604/images/0997b2d90ef0c9db4b378fccd9a0a198956d96c70362400303de922dfc3143d5.png",
    items: ["Corn", "Wheat", "Barley", "Soybean Meal", "Sunflower Meal"],
  },
  {
    id: "industrial-equipment",
    title: "Industrial Equipment",
    description:
      "Complete production lines, processing equipment and industrial components.",
    image:
      "https://images.unsplash.com/photo-1565792508000-8aca4a9be4c3?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
    items: ["Factory machinery", "Processing equipment", "Industrial components"],
  },
  {
    id: "vehicles-transport",
    title: "Vehicles & Transport",
    description:
      "Passenger vehicles, heavy trucks and construction equipment for commercial fleets.",
    image:
      "https://images.unsplash.com/photo-1586191582056-b7f0e16b3a09?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
    items: ["Passenger vehicles", "Heavy trucks", "Construction equipment"],
  },
];

export const MARKETS = [
  {
    id: "europe",
    name: "Europe",
    summary:
      "Established trade corridors across Western, Central and South-Eastern Europe for petrochemicals, agri-commodities and industrial equipment.",
    countries: ["Germany", "Italy", "Netherlands", "Spain", "Romania", "Poland"],
    position: { top: "24%", left: "50%" },
  },
  {
    id: "middle-east",
    name: "Middle East",
    summary:
      "Deep-rooted Gulf relationships driving petrochemical, industrial and infrastructure flows across the region.",
    countries: ["UAE", "Saudi Arabia", "Qatar", "Oman", "Kuwait", "Iraq"],
    position: { top: "44%", left: "58%" },
  },
  {
    id: "central-asia",
    name: "Central Asia",
    summary:
      "Growing demand for rail, industrial and telecommunications infrastructure across the CIS and Caspian markets.",
    countries: ["Kazakhstan", "Uzbekistan", "Turkmenistan", "Azerbaijan", "Georgia"],
    position: { top: "32%", left: "63%" },
  },
  {
    id: "africa",
    name: "Africa",
    summary:
      "Sourcing and distribution across West, East and North African markets — infrastructure, vehicles and agri-commodities.",
    countries: ["Egypt", "Morocco", "Nigeria", "Kenya", "Ethiopia", "South Africa"],
    position: { top: "58%", left: "52%" },
  },
];

export const STATS = [
  { value: "7", label: "Industries served" },
  { value: "40+", label: "Countries covered" },
  { value: "200+", label: "Global partners" },
  { value: "15 yrs", label: "In international trade" },
];

export const CERTIFICATIONS = [
  {
    title: "ISO Compliance",
    body: "Partners audited against ISO 9001 quality management and sector-specific ISO standards.",
    icon: "ShieldCheck",
  },
  {
    title: "International Trade Standards",
    body: "Contracts structured under INCOTERMS 2020 with full compliance to international trade regulations.",
    icon: "Globe2",
  },
  {
    title: "Quality Assurance",
    body: "Pre-shipment inspection, certificate of analysis and documented traceability on every lot.",
    icon: "BadgeCheck",
  },
  {
    title: "Global Logistics Network",
    body: "Bonded warehousing, marine insurance and multimodal freight through trusted logistics partners.",
    icon: "Truck",
  },
];

export const PARTNER_LOGOS = [
  "ARAMCO",
  "BASF",
  "DOW",
  "SABIC",
  "SIEMENS",
  "BOSCH",
  "MAERSK",
  "CATERPILLAR",
  "VOLVO",
  "CARGILL",
  "HUAWEI",
  "BOMBARDIER",
];
